<ng-template #clientTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/jurisdiction/',
      (row.clientId || row.id)
    ]">
    {{ value }}
  </a>
</ng-template>

<ng-template #applicationTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/application/workflow-application/',
      (row.workflowApplicationId || row.id)
    ]">
    {{ value }}
  </a>
</ng-template>

<ng-template #applicationActivityTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/application/workflow-application/',
      row.workflowApplicationId,
      row.activityDataId
    ]">
    {{ value }}
  </a>
</ng-template>

<ng-template #contractorTypeTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/jurisdiction/',
      (row.clientId || row.id),
      'contractors',
      'types',
      'details',
      row.contractorTypeId
    ]">
    {{ value }}
  </a>
</ng-template>

<ng-template #contractorTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/jurisdiction/',
      (row.clientId || row.id),
      'contractors',
      'contractor-profile',
      row.contractorId
    ]">
    {{ value }}
  </a>
</ng-template>


<ng-template #workflowTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/jurisdiction/',
      (row.clientId || row.id),
      'workflows',
      'details',
      row.workflowId
    ]">
    {{ value }}
  </a>
</ng-template>

<ng-template #workflowActivityTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/workflow-builder/',
      row.workflowId
    ]" [queryParams]="{ activityId: row.activityId }">
    {{ value }}
  </a>
</ng-template>

<ng-template #workflowTemplateCodeTemp let-row="row" let-value="value">
  <a target="_blank" [routerLink]="[
      '/admin/workflow-builder/',
      row.workflowId
    ]" [queryParams]="{ activityId: row.activityId, templateCode: row.templateCode }">
    {{ value }}
  </a>
</ng-template>

<h1 class="pt-2">Testing Dashboard</h1>
<h6>Use this tool to find data in the system that meets the needs for your testing.</h6>
<div ngbAccordion #acc="ngbAccordion" class="pt-3">
  <div ngbAccordionItem="workflows" #workflows="ngbAccordionItem" id="workflows" [collapsed]="false"
    class="card-header">
    <h2 ngbAccordionHeader>
      <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
        Search Workflows
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <div class="label">Workflow Type</div>
                <select class="form-control" [(ngModel)]="searchWorkflowRequest.workflowType">
                  <option [ngValue]="null"></option>
                  <option value="0">Permit</option>
                  <option value="4">Renewable</option>
                  <option value="1">Contractor Registration</option>
                  <option value="2">Contractor Renewal</option>
                  <option value="3">Other</option>
                </select>
              </div>

              <div class="card">
                <div class="card-body">
                  <ul ngbNav #activityTypeMethods="ngbNav" class="nav-tabs">
                    <li [ngbNavItem]="'Single'">
                      <a ngbNavLink>Single</a>
                      <ng-template ngbNavContent>
                        <div class="form-group">
                          <div class="label">Activity Type</div>
                          <select class="form-control" [(ngModel)]="searchWorkflowRequest.activityTypes">
                            <option></option>
                            <option *ngFor="let a of activityTypes" [value]="a.type">{{a.name}}</option>
                          </select>
                        </div>
                      </ng-template>
                    </li>
                    <li [ngbNavItem]="'Multiple'">
                      <a ngbNavLink>Multiple</a>
                      <ng-template ngbNavContent>
                        <div class="form-group">
                          <div class="label">Activity Type</div>
                          <select class="form-control" [(ngModel)]="selectedActivityType">
                            <option></option>
                            <option *ngFor="let a of activityTypes" [value]="a.type">{{a.name}}</option>
                          </select>
                          <button class="btn btn-primary btn-raised mt-3"
                            [disabled]="(selectedActivityType || '') == ''"
                            (click)="addActivityTypeClicked()">Add</button>
                        </div>
                        <div class="form-group">
                          <ul>
                            <li *ngFor="let at of selectedActivityTypes">{{activityTypeIdx[at].name}} <a
                                style="cursor: pointer" (click)="removeActivityTypeClicked(at)">X</a></li>
                          </ul>
                        </div>
                      </ng-template>
                    </li>
                  </ul>
                  <div [ngbNavOutlet]="activityTypeMethods"></div>
                </div>
              </div>

              <div class="form-group">
                <div class="label">Data Entity Type</div>
                <select class="form-control" [(ngModel)]="searchWorkflowRequest.dataEntityType">
                  <option></option>
                  <option *ngFor="let de of dataEntityTypes" [value]="de.dataEntityTypeCode">{{de.dataEntityTypeName}}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Custom Lists?</div>
                <select class="form-control" [(ngModel)]="searchWorkflowRequest.hasCustomLists">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <button (click)="searchWorkflowsClicked()" class="btn btn-raised btn-primary">Search Workflows</button>
              &nbsp;<button (click)="clearWorkflowsClicked()" class="btn btn-raised">Clear</button>
            </div>
          </div>


          <div class="pt-3" *ngIf="loading">
            <app-loader></app-loader>
          </div>

          <ngx-datatable class="material mt-3" [columns]="workflowColumns" [rows]="workflowRows"
            [columnMode]="ColumnMode.force" [externalPaging]="true"
            [count]="(searchWorkflowsResponse?.totalRecords || 0)" [offset]="searchWorkflowRequest.page-1"
            [limit]="searchWorkflowRequest.pageSize" (page)="onWorkflowsPaged($event)" [loadingIndicator]="loading"
            [headerHeight]="50" [footerHeight]="50" [messages]="{ emptyMessage: 'No Workflows' }" rowHeight="auto"
            [scrollbarH]="true" #dsWorkflowsGrid *ngIf="workflowColumns && workflowRows">
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
  <div ngbAccordionItem="jurisdictions" #jurisdictions="ngbAccordionItem" id="jurisdictions" class="card-header">
    <h2 ngbAccordionHeader>
      <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
        Search Jurisdictions
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <div class="label">Has Workflow Type {{searchJurisdictionsRequest.workflowType}}</div>
                <select class="form-control" [(ngModel)]="searchJurisdictionsRequest.workflowType">
                  <option [ngValue]="null"></option>
                  <option [ngValue]="0">Permit</option>
                  <option [ngValue]="4">Renewable</option>
                  <option [ngValue]="1">Contractor Registration</option>
                  <option [ngValue]="2">Contractor Renewal</option>
                  <option [ngValue]="3">Other</option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Active Registrations?</div>
                <select class="form-control" [(ngModel)]="searchJurisdictionsRequest.hasActiveRegistrations">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Custom Lists?</div>
                <select class="form-control" [(ngModel)]="searchJurisdictionsRequest.hasCustomLists">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <button (click)="searchJurisdictionsClicked()" class="btn btn-raised btn-primary">Search
                Jurisdictions</button>
              &nbsp;<button (click)="clearJurisdictionsClicked()" class="btn btn-raised">Clear</button>
            </div>
          </div>


          <div class="pt-3" *ngIf="loading">
            <app-loader></app-loader>
          </div>
          <ngx-datatable class="material mt-3" [columns]="jurisdictionColumns" [rows]="jurisdictionRows"
            [columnMode]="ColumnMode.force" [count]="(searchJurisdictionsResponse?.totalRecords || 0)"
            [offset]="searchJurisdictionsRequest.page-1" [limit]="searchJurisdictionsRequest.pageSize"
            (page)="onJurisdictionsPaged($event)" [loadingIndicator]="loading" [headerHeight]="50" [footerHeight]="50"
            [messages]="{ emptyMessage: 'No Jurisdiction' }" rowHeight="auto" [scrollbarH]="true" #dsJurisdictionGrid
            *ngIf="jurisdictionColumns && jurisdictionRows">
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
  <div ngbAccordionItem="inspections" #inspections="ngbAccordionItem" id="inspections" class="card-header">
    <h2 ngbAccordionHeader>
      <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
        Search Inspections
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <div class="label">Has Registrations with status?</div>
                <select class="form-control" [(ngModel)]="searchInspectionsRequest.Status">
                  <option [ngValue]="0">Pending Schedule</option>
                  <option [ngValue]="1">Pending Inspection</option>
                  <option [ngValue]="2">Approved</option>
                  <option [ngValue]="3">Denied</option>
                  <option [ngValue]="4">Deleted</option>
                  <option [ngValue]="5">Voided</option>
                  <option [ngValue]="6">Requested</option>
                  <option [ngValue]="7">Scheduled</option>
                </select>
              </div>

              <button (click)="searchInspectionsClicked()" class="btn btn-raised btn-primary">Search
                Inspections</button>
              &nbsp;<button (click)="clearInspectionsClicked()" class="btn btn-raised">Clear</button>
            </div>
          </div>

          <div class="pt-3" *ngIf="loading">
            <app-loader></app-loader>
          </div>
          <ngx-datatable class="material mt-3" [columns]="inspectionsColumns" [rows]="inspectionsRows"
            [columnMode]="ColumnMode.force" [count]="(searchInspectionsResponse?.totalRecords || 0)"
            [offset]="searchInspectionsRequest.page-1" [limit]="searchInspectionsRequest.pageSize"
            (page)="onInspectionsPaged($event)" [loadingIndicator]="loading" [headerHeight]="50" [footerHeight]="50"
            [messages]="{ emptyMessage: 'No Inspections' }" rowHeight="auto" [scrollbarH]="true" #dsInspectionsGrid
            *ngIf="inspectionsColumns && inspectionsRows">
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
  <div ngbAccordionItem="contractorTypes" #contractorTypes="ngbAccordionItem" id="contractorTypes" class="card-header">
    <h2 ngbAccordionHeader>
      <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
        Search Contractor Types
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <div class="label">Has Registrations with status?</div>
                <select class="form-control" [(ngModel)]="searchContractorTypesRequest.HasRegistrationStatus">
                  <option [ngValue]="null">Ignore</option>
                  <option [ngValue]="0">Pending</option>
                  <option [ngValue]="1">Approved</option>
                  <option [ngValue]="2">Denied</option>
                  <option [ngValue]="3">Expired</option>
                  <option [ngValue]="4">Inactive</option>
                  <option [ngValue]="5">Deleted</option>
                  <option [ngValue]="6">Renewed</option>
                  <option [ngValue]="7">Disabled</option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Requirements?</div>
                <select class="form-control" [(ngModel)]="searchContractorTypesRequest.hasRequirements">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <button (click)="searchContractorTypesClicked()" class="btn btn-raised btn-primary">Search Contractor
                Types</button>
              &nbsp;<button (click)="clearContractorTypesClicked()" class="btn btn-raised">Clear</button>
            </div>
          </div>

          <div class="pt-3" *ngIf="loading">
            <app-loader></app-loader>
          </div>
          <ngx-datatable class="material mt-3" [columns]="contractorTypesColumns" [rows]="contractorTypesRows"
            [columnMode]="ColumnMode.force" [count]="(searchContractorTypesResponse?.totalRecords || 0)"
            [offset]="searchContractorTypesRequest.page-1" [limit]="searchContractorTypesRequest.pageSize"
            (page)="onContractorTypesPaged($event)" [loadingIndicator]="loading" [headerHeight]="50" [footerHeight]="50"
            [messages]="{ emptyMessage: 'No Contractor Types' }" rowHeight="auto" [scrollbarH]="true"
            #dsContractorTypesGrid *ngIf="contractorTypesColumns && contractorTypesRows">
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
  <div ngbAccordionItem="contractors" #contractors="ngbAccordionItem" id="contractors" class="card-header">
    <h2 ngbAccordionHeader>
      <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
        Search Contractors
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <div class="label">Has Registrations with status?</div>
                <select class="form-control" [(ngModel)]="searchContractorsRequest.HasRegistrationStatus">
                  <option [ngValue]="null">Ignore</option>
                  <option [ngValue]="0">Pending</option>
                  <option [ngValue]="1">Approved</option>
                  <option [ngValue]="2">Denied</option>
                  <option [ngValue]="3">Expired</option>
                  <option [ngValue]="4">Inactive</option>
                  <option [ngValue]="5">Deleted</option>
                  <option [ngValue]="6">Renewed</option>
                  <option [ngValue]="7">Disabled</option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Contractor Requirements?</div>
                <select class="form-control" [(ngModel)]="searchContractorsRequest.hasContractorRequirements">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <div class="form-group">
                <div class="label">Has Registration Requirements?</div>
                <select class="form-control" [(ngModel)]="searchContractorsRequest.hasRegistrationRequirements">
                  <option [ngValue]="null">Ignore</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>

              <button (click)="searchContractorsClicked()" class="btn btn-raised btn-primary">Search
                Contractors</button>
                &nbsp;<button (click)="clearContractorsClicked()" class="btn btn-raised">Clear</button>
            </div>
          </div>

          <div class="pt-3" *ngIf="loading">
            <app-loader></app-loader>
          </div>
          <ngx-datatable class="material mt-3" [columns]="contractorsColumns" [rows]="contractorsRows"
            [columnMode]="ColumnMode.force" [count]="(searchContractorsResponse?.totalRecords || 0)"
            [offset]="searchContractorsRequest.page-1" [limit]="searchContractorsRequest.pageSize"
            (page)="onContractorsPaged($event)" [loadingIndicator]="loading" [headerHeight]="50" [footerHeight]="50"
            [messages]="{ emptyMessage: 'No Contractors' }" rowHeight="auto" [scrollbarH]="true" #dsContractorsGrid
            *ngIf="contractorsColumns && contractorsRows">
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
</div>
